import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddProductColor = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState({});
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const handleFormSubmit = async (formData) => {
    console.log("formData", formData);

    const errors = {};
    let isValid = true;

    ProductColorInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // Show confirmation alert before proceeding
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to create a record in Color?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, create",
      cancelButtonText: "No",
    });

    // If the user cancels, exit early
    if (!confirmation.isConfirmed) {
      return;
    }

    try {
      setLoading(true); // Show loading state

      const payload = {
        color_name: formData.name,
        color_desc: formData.description,
        status: formData.status === true ? 1 : 0,
      };

      // Make API request to create color
      const response = await axiosInstance.post("/color/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("API Response:", response.data);

      // If the API call is successful, navigate to the color management page
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Color created successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        navigate("/admin/manage-product/color"); // Navigate after success
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      // Extract error message and show error alert
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      await showAlert({
        title: "Something went wrong",
        text: errorMessage,
        confirmButtonText: "OK",
        callback: () => {
          // Optional: code to execute after confirming the alert
          console.log("Error alert confirmed");
        },
      });
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  const ProductColorInputs = [
    {
      name: "name",
      label: "Name",
      placeholder: "Enter Color",
      type: "text",
      required: true,
      validation: validations.colour({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Color Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                src={backicon}
                alt="back"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
              />
              <span className="backbtntitle">Add Color</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Color Details
              </span>
              <DynamicForm
                formConfig={ProductColorInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(
                    ProductColorInputs,
                    formData,
                    validationErrors,
                  ) || loading
                }
                style={buttonStyle(
                  ProductColorInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddProductColor;
